import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@shared/redux/config-store-state.model';
import { emitAlert } from '@shared/redux/actions/actions-store-state.model';
import { DoctrineApiService } from '@modules/doctrine/doctrine-api.service';
import { AuthorRoleService } from '@shared/services/author-role.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'astrea-doctrine-details',
  templateUrl: './doctrine-details.component.html',
  styleUrls: ['./doctrine-details.component.scss']
})
export class DoctrineDetailsComponent implements OnInit {

  @Input() doctrine!: any;
  public loadingFile = false;
  public authors: any = [];

  constructor(
    private store: Store<AppState>,
    private api: DoctrineApiService,
    private authorRoleService: AuthorRoleService,
    private _t: TranslateService,
  ) { }

  ngOnInit(): void {
    this.buildAuthorsData();
  }

  getFile(bucket: string, bookcode: string): void {
    this.loadingFile = true;
    this.api.getFile({ bucket, bookcode })
      .then(pdf => {
        if (pdf.type.includes('application/json')) {
          this.alertFileError();
        } else if (pdf.type.includes('application/pdf')) {
          window.open(URL.createObjectURL(pdf), '_blank');
        }
        this.loadingFile = false;
      })
      .catch(err => {
        this.alertFileError();
      });
  }

  buildAuthorsData(): void {
    const authorsData = this.authorRoleService.buildAuthorsAndRoles(this.doctrine.authors, this.doctrine.vAuthor);
    this.authors = authorsData.slice(0, 3);
  }

  alertFileError(): void {
    this.store.dispatch(emitAlert({
      message: this._t.instant('alert.file_err'),
      alertType: 'danger'
    }));
  }

}
